import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { Store } from "../Store";
import CheckoutSteps from "../Components/CheckoutSteps";

export default function ShippingAddressPage() {
  const navigate = useNavigate();
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const {
    userInfo,
    cart: { shippingAddress },
  } = state;

  const [fullName, setFullName] = useState(shippingAddress.fullName || "");
  const [phone, setPhone] = useState(shippingAddress.phone || "");
  const [county, setCounty] = useState(shippingAddress.county || ""); // Updated to "county"

  const counties = [
    "Bomet",
    "Bungoma",
    "Busia",
    "Elgeyo-Marakwet",
    "Embu",
    "Garissa",
    "Homa Bay",
    "Isiolo",
    "Kajiado",
    "Kakamega",
    "Kericho",
    "Kiambu",
    "Kilifi",
    "Kirinyaga",
    "Kisii",
    "Kisumu",
    "Kitui",
    "Kwale",
    "Laikipia",
    "Lamu",
    "Machakos",
    "Makueni",
    "Mandera",
    "Marsabit",
    "Mombasa",
    "Murang’a",
    "Nairobi",
    "Nakuru",
    "Nandi",
    "Narok",
    "Nyanza",
    "Samburu",
    "Siaya",
    "Taita Taveta",
    "Tana River",
    "Tharaka Nithi",
    "Trans Nzoia",
    "Turkana",
    "Uasin Gishu",
    "Vihiga",
    "Wajir",
    "West Pokot",
    "Nyandarua",
    "Nyeri",
  ];

  useEffect(() => {
    if (!userInfo) {
      navigate("/signin?redirect=/shipping");
    }
  }, [userInfo, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    console.log("Submitting shipping address");
    ctxDispatch({
      type: "SAVE_SHIPPING_ADDRESS",
      payload: {
        fullName,
        phone,
        county, // Updated to "county"
      },
    });
    console.log("Shipping address saved to context");

    localStorage.setItem(
      "shippingAddress",
      JSON.stringify({
        fullName,
        phone,
        county, // Updated to "county"
      })
    );
    console.log("Shipping address saved to localStorage");

    navigate("/payment");
    console.log("Navigating to /payment");
  };

  return (
    <div>
      <Helmet>
        <title>Shipping Address</title>
      </Helmet>

      <CheckoutSteps step1 step2></CheckoutSteps>
      <div className='row justify-content-center mb-3 '>
        <div className='col-md-8'>
          <h1 className='text-center my-3'>Shipping Address</h1>
          <Form
            style={{ backgroundColor: "#212529", height: "100%" }}
            className='p-4 rounded shadow-sm'
            onSubmit={submitHandler}
          >
            <Form.Group className='mb-3' controlId='fullName'>
              <Form.Label className='text-white'>Full Name</Form.Label>
              <Form.Control
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
                className='bg-white'
              />
            </Form.Group>

            <Form.Group className='mb-3' controlId='city'>
              <Form.Label className='text-white'>Phone Number</Form.Label>
              <Form.Control
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                className='bg-white'
              />
            </Form.Group>

            <Form.Group className='mb-3' controlId='county'>
              <Form.Label className='text-white'>County</Form.Label>
              <Form.Select
                value={county}
                onChange={(e) => setCounty(e.target.value)} // Update onChange
                required
                className='bg-white'
              >
                <option value=''>Select a County</option>
                {counties.map((countyName) => (
                  <option key={countyName} value={countyName}>
                    {countyName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <div className='d-grid gap-2'>
              <Button variant='primary' type='submit'>
                Continue
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
